import React from 'react';
import { Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { toSentenceCase } from '../../utils/casing';

/**
 * Actions shown on a results page's "no quotes / failure" state:
 *   • primary pink "Try again" button — re-requests quotes via the caller's
 *     onRetry handler (which resets the page to its loading state).
 *   • secondary "Take Me Home" link — the existing escape hatch to the landing
 *     page, kept as a fallback.
 */
const NoQuotesActions = ({ onRetry, sx }) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '16px',
        mt: '40px',
        ...sx,
      }}
    >
      <Button
        variant="contained"
        onClick={onRetry}
        sx={{
          width: '175px',
          height: '48px',
          gap: '12px',
          borderRadius: '20px',
          backgroundColor: '#FF0074',
          textTransform: 'none',
          fontFamily: 'Inter',
          fontWeight: 700,
          color: '#FFFFFF',
          fontSize: '1.25rem',
          lineHeight: '24px',
          letterSpacing: '-0.3px',
          '&:hover': { backgroundColor: '#e6006a' },
        }}
      >
        {toSentenceCase('Search Again')}
      </Button>

      <Button
        variant="text"
        onClick={() => navigate('/')}
        sx={{
          textTransform: 'none',
          fontFamily: 'Inter',
          fontWeight: 600,
          color: '#1E354E',
          fontSize: '1rem',
          lineHeight: '24px',
          textDecoration: 'underline',
          '&:hover': {
            backgroundColor: 'transparent',
            color: '#FF0074',
          },
        }}
      >
        {toSentenceCase('Take Me Home')}
      </Button>
    </Box>
  );
};

export default NoQuotesActions;
